import React from 'react';
import Header from '../components/Header';

export default function NavbarInner() {
  return (
    
    <> 
<div className='Navbar_inner'>
<Header /> 

</div>
</>
  )
}
